module.exports = __webpack_public_path__ + "assets/img/combo_box2.292b58e0.png";